import { render } from "./HeroHowWeWork.vue?vue&type=template&id=1b8d0a58&scoped=true"
import script from "./HeroHowWeWork.vue?vue&type=script&lang=js"
export * from "./HeroHowWeWork.vue?vue&type=script&lang=js"

import "./HeroHowWeWork.vue?vue&type=style&index=0&id=1b8d0a58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8d0a58"]])

export default __exports__